export default [
  {
    icon: 'icon-social-facebook',
    href: 'https://facebook.com/domoHQ/timeline/',
  },
  {
    icon: 'icon-social-twitter',
    href: 'https://twitter.com/domotalk',
  },
  {
    icon: 'icon-social-linkedin',
    href: 'https://linkedin.com/company/domo-inc-',
  },
  {
    icon: 'icon-social-instagram',
    href: 'https://instagram.com/domo/',
  },
  {
    icon: 'icon-social-youtube',
    href: 'https://youtube.com/user/DomoTechnologies',
  },
];
